import { render, staticRenderFns } from "./Journalism.vue?vue&type=template&id=e6be74c2&scoped=true"
import script from "./Journalism.vue?vue&type=script&lang=js"
export * from "./Journalism.vue?vue&type=script&lang=js"
import style0 from "./Journalism.vue?vue&type=style&index=0&id=e6be74c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6be74c2",
  null
  
)

export default component.exports